import React, { useEffect, useState } from 'react';
import './WuxingDisplay.css';
import { getWuxingColor, getGanWuxing } from '../utils/wuxing-calculator';

const WuxingDisplay = ({ wuxing, riGan }) => {
  const wuxingData = [
    { name: '金', key: 'jin' },
    { name: '木', key: 'mu' },
    { name: '水', key: 'shui' },
    { name: '火', key: 'huo' },
    { name: '土', key: 'tu' }
  ];

  const total = Object.values(wuxing).reduce((sum, val) => sum + val, 0);
  const maxVal = Math.max(0, ...Object.values(wuxing));

  // 移动端检测：宽度<=576px时按最大值归一化到100%
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mql = window.matchMedia('(max-width: 576px)');
      const update = () => setIsMobile(mql.matches);
      update();
      mql.addEventListener('change', update);
      return () => mql.removeEventListener('change', update);
    }
  }, []);

  // 计算每个五行元素的百分比并按降序排序
  const sortedWuxingData = [...wuxingData].sort((a, b) => {
    const valueA = wuxing[a.key] || 0;
    const valueB = wuxing[b.key] || 0;
    return valueB - valueA; // 降序排列
  });

  // 能量环：五段甜甜圈（生序 木火土金水），比例来自五行占比
  const ringOrder = [
    { name: '木', key: 'mu' },
    { name: '火', key: 'huo' },
    { name: '土', key: 'tu' },
    { name: '金', key: 'jin' },
    { name: '水', key: 'shui' }
  ];
  const R = 44;
  const C = 2 * Math.PI * R;
  let acc = 0;
  const segments = ringOrder.map(({ name, key }) => {
    const val = wuxing[key] || 0;
    const frac = total > 0 ? val / total : 0;
    const len = frac * C;
    const seg = { name, key, color: getWuxingColor(name), len, offset: -acc };
    acc += len;
    return seg;
  });

  const riWuxing = riGan ? getGanWuxing(riGan) : '';
  const riColor = riWuxing ? getWuxingColor(riWuxing) : 'var(--accent-gold-strong)';

  return (
    <div className="wuxing-display">
      <div className="wuxing-layout">
        {/* 五行能量环 */}
        <div className="wx-ring-wrap">
          <svg viewBox="0 0 120 120" className="wx-ring" role="img" aria-label="五行能量环">
            {/* 描边色走 style 而非 SVG 属性：属性值里的 var() 在 Safari 不可靠 */}
            <circle cx="60" cy="60" r={R} fill="none" style={{ stroke: 'var(--bg-elev-2)' }} strokeWidth="15" />
            <g transform="rotate(-90 60 60)">
              {segments.map((s) => (
                s.len > 0 ? (
                  <circle
                    key={s.key}
                    cx="60" cy="60" r={R}
                    fill="none"
                    style={{ stroke: s.color }}
                    strokeWidth="15"
                    strokeDasharray={`${s.len} ${C - s.len}`}
                    strokeDashoffset={s.offset}
                    strokeLinecap="butt"
                  />
                ) : null
              ))}
            </g>
          </svg>
          <div className="wx-ring-center">
            {riGan ? (
              <>
                <span className="wx-ring-gan" style={{ color: riColor }}>{riGan}</span>
                <span className="wx-ring-label">日主</span>
              </>
            ) : (
              <span className="wx-ring-label">五行分布</span>
            )}
          </div>
        </div>

        {/* 五行分布条 */}
        <div className="wuxing-bars">
          {sortedWuxingData.map(({ name, key }) => {
            const value = wuxing[key] || 0;
            const percentTotal = total > 0 ? (value / total) * 100 : 0;
            const percentMax = maxVal > 0 ? (value / maxVal) * 100 : 0;
            const color = getWuxingColor(name);
            const widthPercent = isMobile ? percentMax : percentTotal;
            return (
              <div key={key} className="wuxing-item">
                <span className="wuxing-name" style={{ color }}>{name}</span>
                <span className="wuxing-value">{value.toFixed(2)}</span>
                <div className="wuxing-bar-container">
                  <div className="wuxing-bar" style={{ width: `${widthPercent}%`, background: color }} />
                </div>
                <span className="wuxing-percentage">{percentTotal.toFixed(1)}%</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WuxingDisplay;
